<app-not-refresh-appbar>{{'otp_setting_title' | translate }}</app-not-refresh-appbar>

 <div id="appCapsule">
     
    <div class="container">
        <h3 class="text-center text-white mt-3">{{'otp_setting_desc' | translate }}</h3>
            <!-- {{ otpChannelList | json}} -->
        <div class="row">
            <div class="col-12 mt-2 otp__setting" *ngFor="let otpChannel of otpChannelList;trackBy: trackByOtpChannelList">
                <div class="card">
                    <div class="card-body text-center" [ngClass]="{'active': otpChannel.channel_id === selectedChannel.channel_id}"
                     (click)="onSelectOtpChannel(otpChannel)">   
                           <img [src]="otpChannel.icon_url" class="img-fluid" alt="icon" style="width: 40px; height: 40px;" />
                           <div class="ml-2 text-left">
                                <h4>{{otpChannel.channel_name}}</h4>
                                <p *ngIf="otpChannel.channel_code === 'SMS'">{{ 'sms_des' | translate : {value: otpChannel.destination_masked} }}   </p>
                                <p *ngIf="otpChannel.channel_code === 'VIBER'">{{ 'viber_des' | translate : {value: otpChannel.destination_masked} }}   </p>
                                <p *ngIf="otpChannel.channel_code === 'TELEGRAM'">{{ 'telegram_des' | translate : {value: otpChannel.destination_masked} }}   </p>
                                <p *ngIf="otpChannel.channel_code === 'EMAIL'">{{ 'email_des' | translate : {value: otpChannel.destination_masked== null?'******@gmail.com': otpChannel.destination_masked} }}   </p>
                                <div class="mb-3" *ngIf="otpChannel.channel_code === 'EMAIL' && otpChannel.destination === null && otpChannel.channel_id === selectedChannel.channel_id">
                                    <label for="exampleInputEmail1" class="form-label">Email address</label>             
                                    <input type="email" class="form-control" placeholder="Enter your email"  name="email"
                                     [(ngModel)]="email"  #emailRef="ngModel" (input)="checkEmail(emailRef)" />                                    
                                      <div *ngIf="emailRef.invalid && emailRef.touched" class="error-color">{{ 'invalid_email' | translate }}</div>                    
                                </div>
                            </div>
                           
                                      
                    </div>
                </div>
            </div>         
        </div>
        <p class="text-center text-white mt-3">{{'otp_setting_desc1' | translate : {value: selectedChannel.channel_name} }}</p>
        <!-- <button class="btn btn-primary btn-block mt-3" (click)="onSaveOtpSetting()">{{ 'save' | translate }}</button> -->

    </div>   
    
</div>